import { EsriUtils } from '../utils/esri.utils';
import { ObjectUtils } from '../utils/object.utils';
import { RandomUtils } from '../utils/random.utils';

export enum MapNoteType {
  Point = 'point',
  Line = 'line',
  Polyline = 'polyline',
  FreePolyline = 'free-polyline',
  Arrow = 'arrow',
  Triangle = 'triangle',
  Rectangle = 'rectangle',
  Circle = 'circle',
  Ellipse = 'ellipse',
  Polygon = 'polygon',
  FreePolygon = 'free-polygon',
  Text = 'text',
}

export interface MapNoteModelLike {
  key?: string;
  type: MapNoteType;
  symbolParams: any;
  geometry: __esri.Geometry;
}

export class MapNoteModel implements MapNoteModelLike {
  key: string;
  type: MapNoteType;
  symbolParams: any;
  geometry: __esri.Geometry;

  constructor(obj?: Partial<MapNoteModelLike>) {
    this.key = obj?.key ?? RandomUtils.uniqId();
    this.type = obj?.type;
    this.symbolParams = ObjectUtils.clone(obj?.symbolParams);
    this.geometry = EsriUtils.geometryFromJson(
      ObjectUtils.clone(obj?.geometry)
    );
  }

  clone() {
    return new MapNoteModel(this);
  }
}
